import * as React from "react";
import { SVGProps } from "react";

const Iostoken = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 450 519" {...props}>
    <path d="M225 0 0 129.9v259.8l225 129.9 225-129.9V129.9L225 0zm4.6 420.8L56.9 322.3l.7-47.9 171.9 98.4 82.9-47.8-55.6-32.1-20.8 12-39-22.4 20.9-12.1-27.3-15.8-16.5 9.6-39.1-22.4 16.6-9.6-88.1-50.9 166-95.8 156.6 89.3-42 24.4-114.6-65.7-82.9 47.8 46.4 26.8 23.7-13.8 39.1 22.4-23.9 13.8 27.3 15.8 19.4-11.3 39.1 22.4-19.6 11.4 97.2 56.1-165.7 95.9z" />
  </svg>
);

export default Iostoken;
